import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'append',
  standalone: false
})
export class AppendPipe implements PipeTransform {

  transform(value: string, args?: string): any {
    return value + args;
  }

}
